interface DividerProps {
  style?: 'solid' | 'dashed' | 'dotted' | 'gradient';
  color?: string;
  thickness?: 'thin' | 'medium' | 'thick';
}

const THICKNESS: Record<string, string> = { thin: '1px', medium: '2px', thick: '4px' };

export function DividerBlock({ props }: { props: DividerProps }) {
  const t = THICKNESS[props.thickness ?? 'thin'] ?? '1px';
  const color = props.color || '#e4e4e7';

  if (props.style === 'gradient') {
    return (
      <div className="py-4">
        <div className="h-px" style={{ background: `linear-gradient(to right, transparent, ${color}, transparent)`, height: t }} />
      </div>
    );
  }

  return (
    <div className="py-4">
      <hr style={{ borderStyle: props.style ?? 'solid', borderColor: color, borderWidth: `${t} 0 0 0` }} />
    </div>
  );
}
